import gql from 'graphql-tag';
export const getSolutionQuery = gql`
  query($entityId: ID, $solutionId: ID) {
    solutionCatalogList(id: $solutionId) {
      id
      listingVersion
      developerId
      developerName
      orgId
      solutionType
      status
      submittedOn
      lastUpdatedOn
      solutionType
      overview {
        name
        category
        applicationArea
        version
        briefDescription
        detailedDescription
        publisherName
        website
        solutionWebsite
        copyright
        privacyPolicyUrl
        termsAndConditionsUrl
        solutionLogo
      }
      registration_details {
        api_details {
          id
          name
          displayName
        }
      }
      plans {
        id
        isTheFreeTrial
        isFreeTrialEnabled
        position
        planName
        planDescription
        freeTrialPeriod
        freeTrialPeriodType
        billingType
        transactionalTypeOptions
        includedTransactionalType
        includedTransactionalFee
        billingFrequency
        basePrice
        includedUnitOfMeasure
        includedUnitQuantity
        additionalUnitPrice
        additionalUnitOfMeasure
        features {
          id
          title
          description
          featureImage
        }
      }
      support {
        phoneNumber
        emailAddress
      }
      provisioning_interface {
        endpointUrl
        redirectURL
        provisioningtype
      }
    }
    solutionSubscriptions(entityId: $entityId, solutionId: $solutionId) {
      id
      solutionId
      subscriptionId
      status
      dateOfPurchase
      subscriptionCreatedOn
      subscriptionStartDate
      subscriptionEndDate
      termsAndConditions
      plan {
        id
        planName
      }
    }
  }
`;

// operationName: null
// variables: {solutionId: "24c6fb5b-165d-4e48-b8c8-e9501805363a", listingVersion: "2",…}
// solutionId: "24c6fb5b-165d-4e48-b8c8-e9501805363a"
// listingVersion: "2"
// firstName: "AdminAppTestUser"
// lastName: "Purple"
// entityId: "eb6658c8-ba59-407f-b499-27614bce8fed"
// userId: "admin_app_test_user@cdk.com"
// status: "Pending Activation"
// userProvisioningStatus: "pending"
// provisioningInitiatedOn: "2020-01-15T07:26:33.807Z"
// plan: {id: "e9e4d295-8a19-4e9f-a3fe-e2ee03b7ab48", isTheFreeTrial: true, isFreeTrialEnabled: true,…}
// termsAndConditions: "https://marketplace-dev-solution-docs.s3.amazonaws.com/tnc/f5270428-c7ce-41ba-bfe5-8a816393717b/24c6fb5b-165d-4e48-b8c8-e9501805363a/2/Lorem-Ipsum.pdf"
// subscriptionCreatedOn: "2020-01-15T07:26:33.807Z"

export const createSubscription = gql`
  mutation(
    $solutionId: ID!
    $listingVersion: String!
    $entityId: ID!
    $userId: String
    $firstName: String
    $lastName: String
    $status: String
    $plan: PlanInfoCmd
    $termsAndConditions: String
    $subscriptionCreatedOn: String
    $userProvisioningStatus: String
    $provisioningInitiatedOn: String
    $subscribedSource: String
  ) {
    createSolutionSubscription(
      command: {
        solutionId: $solutionId
        listingVersion: $listingVersion
        entityId: $entityId
        userId: $userId
        firstName: $firstName
        lastName: $lastName
        status: $status
        plan: $plan
        termsAndConditions: $termsAndConditions
        reminderSentOn: null
        userProvisioningStatus: $userProvisioningStatus
        apiActivationStatus: "Not Started"
        subscriptionStartDate: null
        subscriptionEndDate: null
        subscriptionCreatedOn: $subscriptionCreatedOn
        provisioningInitiatedOn: $provisioningInitiatedOn
        subscribedSource: $subscribedSource
      }
    ) {
      id
      subscriptionId
      userId
      dateOfPurchase
    }
  }
`;

// emailAddress: "admin_app_test_user@cdk.com"
// emailSubject: "New Subscription - Free Trial"
// firstName: "AdminAppTestUser"
// emailType: "solutionSubscriptionDeveloperEmail"
// solutionName: "consent12 test"
// solutionId: "24c6fb5b-165d-4e48-b8c8-e9501805363a"
// solutionType: "f"
// buyerName: "Rajans Test Org"
// buyerEmail: "admin_app_test_user@cdk.com"
// purchaseDate: "15 Jan 2020"
// planName: "Free Trial"
// planDetails: "1 users"
// subscriptionId: "ebc24809-f53f-4a85-ab8c-99f2231bcfc0"
// entityId: "eb6658c8-ba59-407f-b499-27614bce8fed"

export const subscriptionBuyerEmailMutation = gql`
  mutation(
    $emailAddress: String!
    $emailSubject: String!
    $firstName: String!
    $emailType: String!
    $solutionName: String
    $solutionId: String
    $publisher: String
    $publisherEmail: String
    $publisherPhone: String
    $buyerName: String
    $purchaseDate: String
    $planName: String
    $planDetails: String
    $subscriptionId: String
    $cmfNumber: String
  ) {
    sendEmail(
      command: {
        emailAddress: $emailAddress
        emailSubject: $emailSubject
        userDetails: { firstName: $firstName }
        withTemplate: {
          emailType: $emailType
          solutionName: $solutionName
          solutionId: $solutionId
          publisher: $publisher
          publisherEmail: $publisherEmail
          publisherPhone: $publisherPhone
          subscriptionDetails: {
            buyerName: $buyerName
            purchaseDate: $purchaseDate
            planName: $planName
            planDetails: $planDetails
            subscriptionId: $subscriptionId
          }
        }
        cmfNumber: $cmfNumber
      }
    ) {
      emailResponse
    }
  }
`;

export const solutionProviderEmailMutation = gql`
  mutation(
    $emailAddress: String!
    $emailSubject: String!
    $firstName: String!
    $emailType: String!
    $solutionName: String
    $solutionId: String
    $solutionType: String
    $buyerName: String
    $subscriptionId: String
    $entityId: String
  ) {
    sendEmail(
      command: {
        emailAddress: $emailAddress
        emailSubject: $emailSubject
        userDetails: { firstName: $firstName }
        withTemplate: {
          emailType: $emailType
          solutionName: $solutionName
          solutionId: $solutionId
          solutionType: $solutionType
          subscriptionDetails: {
            buyerName: $buyerName
            subscriptionId: $subscriptionId
            entityId: $entityId
          }
        }
      }
    ) {
      emailResponse
    }
  }
`;

export const unsubscribeMutation = gql`
  mutation(
    $subscriptionId: String!
    $status: String!
    $id: String!
    $subscriptionDisabledBy: String!
  ) {
    unsubscribeSolution(
      command: {
        subscriptionId: $subscriptionId
        status: $status
        id: $id
        subscriptionDisabledBy: $subscriptionDisabledBy
      }
    ) {
      status
      error
    }
  }
`;

export const getSubscriptionQuery = gql`
  query($subscriptionId: ID) {
    getSubscription(subscriptionId: $subscriptionId) {
      subscriptionId
      entityId
      solutionId
      status
      connections {
        api
        solutionId
        connectionId
        providerId
        subscriptionId
        entityId
        status
        apiDisplayName
      }
    }
  }
`;

export const getProviders = gql`
  query($apiIds: [ID]) {
    providers(provides: $apiIds) {
      id
      name
      entityId
      productName
      api
      fqdn
      adminAPIUrl
      addendumDoc
      supportEmail
      supportPhone
      addendum {
        coordinates {
          signatureCoordinates {
            page
            x
            y
          }
        }
        docSize {
          height
          width
        }
      }
    }
  }
`;

export const enableConnectionMutation = gql`
  mutation($enableCmd: enableConnectionCmd) {
    enableConnection(command: $enableCmd) {
      connectionId
      providerId
      api
      subscriptionId
      entityId
      solutionId
      status
    }
  }
`;

export const apiProvidersListForSubscription = gql`
  query($solutionId: String!, $entities: [String], $subscriptionId: String) {
    apiProvidersListForSubscription(
      solutionId: $solutionId
      entities: $entities
      subscriptionId: $subscriptionId
    ) {
      provider {
        id
        api
        name
        productName
        addendumDoc
        entityId
        addendum {
          coordinates {
            signatureCoordinates {
              page
              x
              y
            }
          }
          docSize {
            height
            width
          }
        }
      }
      consents {
        consent {
          consentId
          status
          consentType
          apiProviderId
          organizationId
        }
      }
      subscriptions {
        connections {
          solutionId
          subscriptionId
          entityId
          status
          api
          connectionId
          apiDisplayName
        }
      }
    }
  }
`;

export const getActiveInactiveSolnSubscriptionQry = gql`
  query($solutionId: ID, $entityId: [ID]) {
    solutionActiveInactiveSubscriptions(
      solutionId: $solutionId
      entityId: $entityId
    ) {
      active {
        id
        subscriptionId
        listingVersion
        solutionId
        entityId
        userId
        status
        plan {
          id
          planName
        }
        dateOfPurchase
        solution {
          id
          developerId
          submittedOn
          overview {
            name
            version
            solutionLogo
            publisherName
          }
          registeredOn
        }
        reminderSentOn
        apiActivationStatus
        subscriptionStartDate
        subscriptionEndDate
        billingStartsOn
        billingEndsOn
        subscriptionCreatedOn
        subscriptionCompletedByEmail
        subscriptionCompletedBy
      }
      inactive {
        id
        subscriptionId
        listingVersion
        solutionId
        entityId
        userId
        status
        plan {
          id
          planName
        }
        dateOfPurchase
        solution {
          id
          developerId
          submittedOn
          overview {
            name
            version
            solutionLogo
            publisherName
          }
          registeredOn
        }
        reminderSentOn
        apiActivationStatus
        subscriptionStartDate
        subscriptionEndDate
        billingStartsOn
        billingEndsOn
        subscriptionCreatedOn
        subscriptionCompletedByEmail
        subscriptionCompletedBy
      }
    }
  }
`;

export const solutionProviderCSMSGEmailMutation = gql`
  mutation(
    $to: [csmsgEmailInput]!
    $emailSubject: String!
    $firstName: String!
    $emailType: String!
    $solutionName: String
    $solutionId: String
    $solutionType: String
    $buyerName: String
    $subscriptionId: String
    $attachments: [csmsgEmailAttachmentInput]
    $entityId: String
    $subscriberName: String
    $subscriberOrganization: String
  ) {
    sendEmailCSMG(
      command: {
        to: $to
        subject: $emailSubject
        userDetails: { firstName: $firstName }
        withTemplate: {
          emailType: $emailType
          solutionName: $solutionName
          solutionId: $solutionId
          solutionType: $solutionType
          subscriptionDetails: {
            buyerName: $buyerName
            subscriptionId: $subscriptionId
            entityId: $entityId
            subscriberName: $subscriberName
            subscriberOrganization: $subscriberOrganization
          }
        }
        attachments: $attachments
      }
    ) {
      emailResponse
    }
  }
`;

export const internalBuyerSubscriptionEmailMutation = gql`
  mutation(
    $emailSubject: String!
    $subscriberOrganization: String
    $emailType: String!
    $entityId: String
    $subscriberName: String
    $buyerEmail: String
    $appName: String
    $appId: String
    $appOrgName: String
    $appOrgId: String
    $appTermsConsentType: String
    $buyerName: String
    $apis: [apiDetailCmd]
    $cmfNumber: String
    $attachments: [csmsgEmailAttachmentInput]
  ) {
    sendEmailCSMG(
      command: {
        subject: $emailSubject
        withTemplate: {
          emailType: $emailType
          cmf: $cmfNumber
          appDetails: {
            appName: $appName
            appId: $appId
            appOrgName: $appOrgName
            appOrgId: $appOrgId
            appTermsConsentType: $appTermsConsentType
          }
          apiDetails: $apis
          subscriptionDetails: {
            buyerName: $buyerName
            subscriberOrganization: $subscriberOrganization
            entityId: $entityId
            subscriberName: $subscriberName
            buyerEmail: $buyerEmail
          }
        }
        attachments: $attachments
      }
    ) {
      emailResponse
    }
  }
`;

export const subscriptionBuyerEmailNotificationMutation = gql`
  mutation(
    $to: [csmsgEmailInput]!
    $cc: [csmsgEmailInput]!
    $emailSubject: String!
    $firstName: String!
    $emailType: String!
    $solutionName: String
    $solutionId: String
    $publisher: String
    $publisherEmail: String
    $publisherPhone: String
    $buyerName: String
    $purchaseDate: String
    $planName: String
    $planDetails: String
    $subscriptionId: String
    $attachments: [csmsgEmailAttachmentInput]
    $cmfNumber: String
  ) {
    sendEmailCSMG(
      command: {
        to: $to
        cc: $cc
        subject: $emailSubject
        userDetails: { firstName: $firstName }
        withTemplate: {
          emailType: $emailType
          solutionName: $solutionName
          solutionId: $solutionId
          publisher: $publisher
          publisherEmail: $publisherEmail
          publisherPhone: $publisherPhone
          subscriptionDetails: {
            buyerName: $buyerName
            purchaseDate: $purchaseDate
            planName: $planName
            planDetails: $planDetails
            subscriptionId: $subscriptionId
          }
        }
        attachments: $attachments
        cmfNumber: $cmfNumber
      }
    ) {
      emailResponse
    }
  }
`;

export const entitiesFromPlatform = gql`
  query($id: ID) {
    entitiesFromPlatform(id: $id) {
      id
      name
      lastUpdated
      created
      address {
        region
        street
        countryCode
        postalCode
        city
      }
      phone
      name
      type
      createdBy
      status
      lastUpdatedBy
      version
    }
  }
`;

export const getDataRightsConsentSigningUrlQuery = gql`
  query(
    $id: String
    $firstName: String
    $lastName: String
    $email: String
    $date: String
    $redirectUrl: String
    $emailForBusinessRole: String
  ) {
    dataRightsConsentSigningUrl(
      id: $id
      firstName: $firstName
      lastName: $lastName
      email: $email
      date: $date
      redirectUrl: $redirectUrl
      emailForBusinessRole: $emailForBusinessRole
    ) {
      signingTransactionId
      links {
        href
        rel
        mediaType
        method
      }
    }
  }
`;